import axiosInstance from './axios';

const uploadFiletoServer = (file) => {
  const formData = new FormData();
  formData.append('name', file.name.split('.')[0]);
  formData.append('type', 'location');
  formData.append('template', file);
  return axiosInstance.post('/template', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default uploadFiletoServer;
